import { useId } from 'react';

interface FieldDescription {
  controlId: string;
  labelId: string;
  errorId?: string;
  helperId?: string;
  describedBy?: string;
  invalid: boolean;
}

const describeField = (
  controlId: string,
  error?: string,
  helperText?: string
): FieldDescription => {
  const errorId = error ? `${controlId}-error` : undefined;
  const helperId = helperText ? `${controlId}-helper` : undefined;
  const describedBy =
    [errorId, helperId].filter((part): part is string => Boolean(part)).join(' ') || undefined;

  return {
    controlId,
    labelId: `${controlId}-label`,
    errorId,
    helperId,
    describedBy,
    invalid: Boolean(error)
  };
};

export const useFieldDescription = (
  id: string | undefined,
  error?: string,
  helperText?: string
): FieldDescription => {
  const generatedId = useId();

  return describeField(id ?? generatedId, error, helperText);
};
